import PropTypes from 'prop-types';
import States from 'ContentUtils/constants/States';
import StateStatusGroups from 'ContentUtils/constants/StateStatusGroups';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hasState = (statusGroup, state) => statusGroup.includes(state);
const StateStatus = ({
  state = States.DRAFT,
  useTag = false
}) => {
  const isScheduled = hasState(StateStatusGroups.SCHEDULED, state);
  const isPublished = hasState(StateStatusGroups.PUBLISHED, state);
  let stateType = 'default';
  if (isPublished) {
    stateType = 'success';
  } else if (isScheduled) {
    stateType = 'warning';
  }
  return useTag ? /*#__PURE__*/_jsx(Tag, {
    use: "default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `manage.listing.cells.state.${state}`
    })
  }) : /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(StatusDot, {
      use: stateType
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: `manage.listing.cells.state.${state}`
    })]
  });
};
StateStatus.propTypes = {
  state: PropTypes.string,
  useTag: PropTypes.bool
};
export default StateStatus;